import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'components';
import classNames from 'classnames/bind';

import { Link } from '@beef/ui-kit';
import styles from './styles.pcss';
import { ServiceDownloadUrlList } from './ServiceDownloadUrlList';
import { ServiceDownloadUrl } from './ServiceDownloadUrl';

const cx = classNames.bind(styles);

export const ServiceParams = ({
  downloadUrls, login, password, installUrl, manualUrl, mobileRegion, internetRegion,
}) => (
  <div className={cx('params')}>
    {login && <I18n path="internet.antivirus.login" vars={{ login }} />}
    {password && <I18n path="internet.antivirus.password" vars={{ password }} />}
    {manualUrl && (
      <>
        <Link href={manualUrl} target="_blank">
          <I18n path="internet.antivirus.manualUrl" />
        </Link>
        <br />
      </>
    )}
    {installUrl && (
      <Link href={installUrl} target="_blank">
        <I18n path="internet.antivirus.installUrl" />
      </Link>
    )}

    <ServiceDownloadUrlList downloadUrls={downloadUrls}>
      {(downloadUrl) => <ServiceDownloadUrl {...downloadUrl} />}
    </ServiceDownloadUrlList>

    {mobileRegion && <I18n path="internet.multiconvergence.mobileRegion" vars={{ mobileRegion }} />}
    {internetRegion && <I18n path="internet.multiconvergence.internetRegion" vars={{ internetRegion }} />}
  </div>
);

ServiceParams.propTypes = {
  downloadUrls: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      url: PropTypes.string,
      language: PropTypes.string,
      platform: PropTypes.string,
    }),
  ),
  mobileRegion: PropTypes.string,
  internetRegion: PropTypes.string,
  login: PropTypes.string,
  password: PropTypes.string,
  installUrl: PropTypes.string,
  manualUrl: PropTypes.string,
};
